if (!customElements.get("cart-drawer-upsell")) {
  class CartUpsellSlider extends HTMLElement {
    constructor() {
      super();
      this.swiperContainer = this.querySelector(".swiper-container");
      this.swiperInstance = null;
      this.handleResize = this.handleResize.bind(this);
    }
  
    connectedCallback() {
      this.waitForSwiper(() => {
        this.initSwiper();
        window.addEventListener("resize", this.handleResize);
      });
    }
  
    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
      window.removeEventListener("resize", this.handleResize);
    }
  
    waitForSwiper(trigger) {
      let interval = setInterval(() => {
        if (typeof Swiper !== "undefined") {
          clearInterval(interval);
          trigger();
        }
      }, 50);
      setTimeout(() => clearInterval(interval), 15000);
    }
  
    initSwiper() {
      if (this.swiperContainer) {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
        }
  
        this.swiperInstance = new Swiper(this.swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next-custom",
            prevEl: ".swiper-button-prev-custom",
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
          },
        });
      }
    }
  
    handleResize() {
      this.initSwiper();
    }
  }
  
  customElements.define("cart-drawer-upsell", CartUpsellSlider);  
}


class CartDrawerProductForm extends HTMLElement {
  constructor() {
    super();
    this.addButton = this.querySelector(".form__add");
    this.cart = document.querySelector("cart-drawer");
    this.addToCart = this.addToCart.bind(this);
  }

  connectedCallback() {
    if (this.addButton && !this.addButton.classList.contains("disabled")) {
      this.addButton.addEventListener("click", this.addToCart);
    }
  }

  disconnectedCallback() {
    if (this.addButton) {
      this.addButton.removeEventListener("click", this.addToCart);
    }
  }

  async addToCart() {
    const variantId = this.addButton.dataset.variantId;
    if (!variantId) return;
    this.addButton.classList.add("loading");

    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
      }
      
      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Failed to add to cart");

      const cartData = await response.json();
      
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "product-form",
        productVariantId: variantId,
        cartData: cartData,
      });

      this.addButton.classList.remove("loading");
      this.cart.renderContents(cartData);
    } catch (error) {
      console.error(error);
      this.addButton.classList.remove("loading");
      this.cart.renderContents(cartData);
    }
  }
}

customElements.define("cart-drawer-product-form", CartDrawerProductForm);

